import { Stack } from '@mantine/core';
import DocumentFristenSettings from './DocumentFristenSettings';
import DocumentTemplateList from './DocumentTemplateList';

const DocumentTemplatesSection = () => (
  <Stack sx={{ maxWidth: 500 }}>
    <DocumentTemplateList />
    <DocumentFristenSettings />
  </Stack>
);

export default DocumentTemplatesSection;
